import { useTheme } from '@mui/material';

import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQ`,
  description: `AWS Cloud development services with Rumble Fish`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'Q: What type of cloud services does Rumble Fish offer?',
      description: `A: Rumble Fish as your cloud development partner offers you an array of AWS cloud development services, such as cloud app development, cloud architecture development, DevOps services, cloud deployment services, and cloud migration services. If the service you’re looking for is not on the list, <a href="mailto:hello@rumblefish.dev">contact us directly</a> and we’ll find a solution for you.`,
      gradientOnFocus: theme.mixins.orangeGradient?.background as string,
    },

    {
      title: 'Q: What is cloud application development?',
      description: `A:
       Cloud-based software, or applications, operate in the cloud and are accessible through web browsers and APIs. They mimic the functionality of native apps, with servers typically located in remote data centers managed by third-party providers.
       <br />
       Development of cloud-based apps can be gradual, allowing for cost savings as components are implemented step by step. Major cloud providers offer competitive pricing due to their large-scale operations, enhancing data security as well.
       <br />
       These services provide infrastructure for enterprise-grade security measures at lower costs, and they enable easy scalability and management. Unlike web applications, cloud apps can function offline, updating content online as needed, while web apps require a continuous internet connection.
       `,
      gradientOnFocus: theme.mixins.redGradient?.background as string,
    },
    {
      title: 'Q: What are the benefits of cloud applications?',
      description: `A:
        Cloud computing services eliminate upfront costs for businesses, as they don't need to invest in servers or data centers. Major providers ensure high availability with global data center networks. Some services, like serverless solutions, require minimal management from the client's perspective, allowing developers to focus solely on coding and deployment.
        <br />
        Cloud migration reduces server deployment time from days to minutes, accelerating time to market. Access to abundant resources enables innovation, giving businesses a competitive edge. Providers offer cost optimization solutions such as on-demand instances and discounts for prolonged resource use.
        <br />
        Cloud solutions automatically scale to meet growing traffic demands without the need for additional in-house servers, saving businesses from extra costs and maintenance burdens.
      `,
      gradientOnFocus: theme.mixins.magentaGradient?.background as string,
    },
    {
      title: 'Q: Why hire Rumble Fish for Cloud Applications Development?',
      description: `A: Rumble Fish experts have extensive experience in designing and building cloud-based solutions working with global companies and corporations. We understand the importance of having stable and secure, yet fast and broadly available systems. We are experts in custom cloud solutions based on AWS services. Contact us to learn more and see how you can save time on money through technology.`,
      gradientOnFocus: theme.mixins.purpleGradient?.background as string,
    },
  ];
};
